/**
 * Per-tenant home-env map. `getHomeEnv()` (runtimeHomeEnv) is the DEPLOYMENT's
 * own env (from /api/app-env), NOT a tenant's authoring home — on the uat portal
 * it's `uat`. But promotion state is authoritative on the TENANT's home (e.g.
 * dev01), which useTenantEditability resolves per tenant. This module bridges
 * that async, per-tenant value into the synchronous axios request router so
 * home-authoritative reads route to `dosa.<tenant home>`, not the portal.
 *
 * Separate module (like runtimeHomeEnv) so tests mocking axiosClient don't
 * shadow it. Populated by useTenantEditability; read by crossEnvRequestRouter.
 */
const tenantHome = new Map<string, string>();

/** Record a tenant's authoring home env (called when editability resolves). */
export const setTenantHome = (tenantCode: string, env: string): void => {
  if (tenantCode && env) tenantHome.set(tenantCode, env);
};

/** The tenant's authoring home env, or undefined if not yet resolved. */
export const getTenantHome = (
  tenantCode: string | undefined,
): string | undefined => (tenantCode ? tenantHome.get(tenantCode) : undefined);

/** Test-only: clear the map between cases. */
export const _clearTenantHome = (): void => tenantHome.clear();
